import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import Api from "../../network/Api";
import { Lesson } from "../../types/Lessons";
import { Button, Divider, FormGroup } from "@mui/material";
import LessonSearch from "../Lessons/Search";

const LessonSelection = () => {

  const [lessons, setLessons] = useState<Array<Lesson>>([]);
  const [page, setPage] = useState<number>(1);
  const [selectedLessons, setSelectedLessons] = useState<Array<string>>([]);
  
  useEffect(() => {
    Api.get(`/solutions/new?page=${page}`).then(result => {
      setLessons([...lessons, ...result.items]);
      if (result.total > (lessons.length + result.items.length)) {
        setPage(page + 1);
      }
    });
  }, [page]);
  
  const columns: GridColDef[] = [
    {
      field: 'headline',
      headerName: 'First name',
      flex: 1
    },
    {
      field: 'origin',
      headerName: 'Origin',
    }
  ];

  const createSolution = () => {
    if (selectedLessons.length <= 0) { return; }
    Api.post('/solutions', {lessons: selectedLessons}).then(result => {
      window.location.replace(result.url);
    });
  }

  return <>
    {/* <FormGroup>
      <LessonSearch onClick={lesson => setSelectedLessons([...lesson.id])} />
    </FormGroup> */}

    <FormGroup>
      <DataGrid
        rows={lessons}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[5, 10, 25]}
        checkboxSelection
        onRowSelectionModelChange={(ids: GridRowSelectionModel) => {
          setSelectedLessons([...ids.ids].map(String));
        }}
      />
    </FormGroup>

    <Divider />

    <FormGroup>
      <Button variant="outlined" 
              size="small"
              color="primary"
              disabled={selectedLessons.length <= 0}
              onClick={createSolution}>Start solution process with {selectedLessons.length} issues.</Button>
    </FormGroup>
  </>;
}

export default LessonSelection;